import { create } from 'zustand';

/** Network health — never persisted. */
type ConnectivityState = {
  online: boolean;
  wsConnected: boolean;
  lastApiSuccessAt: number | null;
  setOnline: (online: boolean) => void;
  setWsConnected: (wsConnected: boolean) => void;
  markApiSuccess: () => void;
};

export const useConnectivityStore = create<ConnectivityState>((set) => ({
  online: navigator.onLine,
  wsConnected: false,
  lastApiSuccessAt: null,
  setOnline: (online) => set({ online }),
  setWsConnected: (wsConnected) => set({ wsConnected }),
  markApiSuccess: () => set({ lastApiSuccessAt: Date.now() }),
}));
